import React, { ReactNode } from 'react';

interface DashboardGridProps {
  children: ReactNode;
  columns?: {
    default?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
}

const DashboardGrid: React.FC<DashboardGridProps> = ({
  children,
  columns = { default: 1, md: 2, lg: 3 },
  gap = 'md',
  className = ''
}) => {
  const gapClasses = {
    sm: 'gap-3',
    md: 'gap-4 lg:gap-6',
    lg: 'gap-6 lg:gap-8'
  };

  const getGridClasses = () => {
    const classes = ['grid'];
    
    // Default columns
    if (columns.default) {
      classes.push(`grid-cols-${columns.default}`);
    }
    
    // Responsive columns
    if (columns.sm) {
      classes.push(`sm:grid-cols-${columns.sm}`);
    }
    if (columns.md) {
      classes.push(`md:grid-cols-${columns.md}`);
    }
    if (columns.lg) {
      classes.push(`lg:grid-cols-${columns.lg}`);
    }
    if (columns.xl) {
      classes.push(`xl:grid-cols-${columns.xl}`);
    }
    
    // Gap
    classes.push(gapClasses[gap]);
    
    return classes.join(' ');
  };

  return (
    <div className={`${getGridClasses()} ${className}`}>
      {children}
    </div>
  );
};

export default DashboardGrid;